module.exports = __webpack_public_path__ + "static/media/default-route-map.726f078e.png";